// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"740":"438cf3567cd04b68","2888":"2a9129ecaa37f08a"}[chunkId] + ".css";
};